import { Row, Form, Radio, DatePicker, Select, Col, Space, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import ButtonLink from 'components/theme_components/ButtonLink';
import TextArea from 'antd/lib/input/TextArea';
import {
  addParRate,
  addParRateValue,
  ParRateResponse,
  ParRateValue,
  updateParRateValue,
} from 'services/parametersService';
import ParListSelect from 'components/ParListSelect';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'components/Auth/Auth';
import InputRate from 'components/InputRate';
import IBasket from 'icons/IBasket';
import ModalSFS from 'components/theme_components/ModalSFS';
import ParRateModal from './ParRateModal';
import ParRateStatusModal from './ParRateStatusModal';
import moment from 'moment';
import Notifications from 'components/theme_components/Notifications';
import { toDatePickerDate } from 'utils/utilsSFS';

export type ParRateValueModalProps = {
  setVisible: (visible: boolean) => void;
  setAddRateValue?: (addRateValue: boolean) => void;
  data: ParRateValue;
  refetch: any;
  ratecode: any;
  endDatePrevious?: any;
};

const ParRateValueModal = ({
  setVisible,
  setAddRateValue,
  data,
  endDatePrevious,
  refetch,
  ratecode,
}: ParRateValueModalProps) => {
  const [form] = useForm();
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleSussp, setModalVisibleSussp] = useState(false);

  const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);
  console.log({ data });
  const id = undefined;
  useEffect(() => {
    if (data) {
      const defaultBeginDate = endDatePrevious
      ? toDatePickerDate(moment(endDatePrevious).add(1, 'days').toISOString())
      : toDatePickerDate(String(moment()));

      form.setFieldsValue({
        ...data,

        begindate: data.begindate
          ? toDatePickerDate(data.begindate)
          : defaultBeginDate,
        enddate: toDatePickerDate(data.enddate),
      });
    }
  }, []);
  const submit = (values: any) => {
    const endDateValue = form.getFieldValue('enddate');
    const request: any = {
      ratecode: ratecode,
      begindate: form.getFieldValue('begindate')?.local().format('YYYY-MM-DD'),
      enddate: endDateValue === '' ? endDateValue : endDateValue?.local().format('YYYY-MM-DD'),
      ratevalue: form.getFieldValue('ratevalue'),
      ratevalueid: form.getFieldValue('ratevalueid') ?? -1,
    };
    request.ratevalueid === -1
      ? addParRateValue({ request: request }).then((res) => {
          if (res.code === '200') {
            Notifications({
              status: 'success',
              message: 'Le taux a été modifié avec succès',
              description: res.description,
              duration: 3,
              placement: 'top',
            });
            setVisible(false);
            refetch();
          }
        })
      : updateParRateValue({
          request: request,
          ratevalueid: request.ratevalueid,
        }).then((res) => {
          setVisible(false);

          refetch();
          Notifications({
            status: 'success',
            message: res.message,
            description: res.description,
            duration: 3,
            placement: 'top',
          });
        });
  };

  return (
    <Form form={form} className="no-border-radius ut-wizard-form">
      <Row gutter={16} justify="space-between">
        <FormInput
          col
          xs={11}
          lg={11}
          name="begindate"
          className="form-item no-border-radius"
          layout="vertical"
          rules={[{ required: true }]}
        >
          <DatePicker
            className="form-item no-border-radius"
            format={{
              format: 'DD-MM-YYYY',
              type: 'mask',
            }}
          />
        </FormInput>
        <FormInput
          col
          xs={11}
          lg={11}
          name="enddate"
          className="form-item no-border-radius"
          layout="vertical"
        >
          <DatePicker
            className="form-item no-border-radius"
            format={{
              format: 'DD-MM-YYYY',
              type: 'mask',
            }}
          />
        </FormInput>

        <FormInput
          col
          xs={11}
          lg={11}
          name="ratevalue"
          labelCol={{ span: 24 }}
          className="no-border-radius "
          rules={[{ required: true, message: 'Please enter ratevalue' }]}
        >
          <InputRate className="form-item no-border-radius" />
        </FormInput>
      </Row>

      <div className="d-flex justify-between align-center pt-4">
        <div>
          {/* <ModalSFS
            className="color-gray"
            trigger={({ setVisible }) => (
              <ButtonLink
                className="ut-reset-btn ut-btn-no-border no-box-shadow mr-4 btn-supp "
                comcode="Supprate"
                icon={<IBasket />}
                onClick={() => !isInspect && setVisible(true)}
              />
            )}
            title="suspensValidation"
            footer
            width={560}
          >
            <ParRateStatusModal setVisible={setVisible} data={data} />
          </ModalSFS> */}
        </div>
        <Space>
          <ButtonLink
            comcode="Annuler"
            className="ut-btn-bordred"
            onClick={() => setVisible(false)}
          />

          <ButtonLink
            type="primary"
            comcode="Valider"
            htmlType="submit"
            className="ut-reset-btn ml-6"
            onClick={async () => {
              const values = await form.validateFields();
              submit(values);
            }}
            iconPosition="end"
          />
        </Space>
      </div>
      <ConfirmModal
        visible={modalVisible}
        status="error"
        message="Le taux existe déjà"
        description="Voulez-vous le mettre à jour ?"
        onConfirm={() => {
          setModalVisible(false);
        }}
        onCancel={() => !isInspect && setModalVisible(false)}
        className="modalConfirmOrCancel"
      />
      <ConfirmModal
        visible={modalVisibleSussp}
        status="error"
        message="Le taux est utilisé dans une formule"
        description="La suspension est impossible"
        onConfirm={() => {
          setModalVisible(false);
          setModalVisibleSussp(false);
        }}
        onCancel={() => !isInspect && setModalVisibleSussp(false)}
        className="modalConfirmOrCancel"
      />
    </Form>
  );
};

export default ParRateValueModal;
